import { EColors } from "common/styles";


export const GOOGLE_KEY = 'AIzaSyAKncTpO6ELHh0b83XwUqjp08D_QYq94QE';

export const markers = [
    {
        lat: 50.93898095637447,
        lng: 34.78413508650581,
    },
    {
        lat: 51.250566234096524,
        lng: 33.20962309999999,
    },
    {
        lat: 51.64337161210311,
        lng: 33.91687618650581,
    },
    {
        lat: 51.948669664705044,
        lng: 33.78832942883606,
    },
];

export const darkTheme = [
    {
        elementType: "geometry",
        stylers: [
            {
                color: `${EColors.neutral_600}`,
            },
        ],
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#c9b2a6",
            },
        ],
    },
    {
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#f5f1e6",
            },
        ],
    },
    {
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: `${EColors.neutral_600}`,
            },
        ],
    },
    {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
            {
                color: `${EColors.neutral_700}`,
            },
        ],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#f5f1e6",
            },
        ],
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            {
                color: "#424242",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
            {
                color: "#424242",
            },
        ],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#424242",
            },
        ],
    },
    {
        featureType: "road.highway.controlled_access",
        elementType: "geometry",
        stylers: [
            {
                color: "#424242",
            },
        ],
    },
    {
        featureType: "road.highway.controlled_access",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#424242",
            },
        ],
    },
    {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#181817",
            },
        ],
    },
];